export const LENGTH = {
  THIN: `thin`,
  WIDE: `wide`,
};

export const SIZE = {
  SMALL: `small`,
  MEDIUM: `medium`,
  LARGE: `large`,
};

export enum TEXT_HIGHLIGHT_THEME {
  GENERIC = `generic`,
  LIGHT = `light`,
  INFORMATION = `information`,
  SUCCESS = `success`,
  DELETED = `deleted`,
  FAILED = `failed`,
  POSITIVE = `positive`,
  NEGATIVE = `negative`,
  NEUTRAL = `neutral`,
}

export type TextHighlightProps = {
  icon?: string;
  length?: string;
  markdown?: string;
  size?: string;
  text?: string;
  theme?: TEXT_HIGHLIGHT_THEME;
  textBeforeIcon?: boolean;
  noWrap?: boolean;
  className?: string;
  elref?: string;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
  style?: React.CSSProperties;
};
